import { Injectable } from '@angular/core';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { Observable } from 'rxjs';
import { MarcaModel } from '../Modelo/Marca.model';

@Injectable({
    providedIn: 'root'
})
export class MarcasService {

    constructor(
        private Utilidades: UtilidadesService
    ) { }

    public Lista(): Observable<MarcaModel[]> {
        return this.Utilidades.Get("Marcas");
    }
}